import React from 'react';

export const RegisterHeader = () => (
    <>
        <h2 className="fs-20 fw-bolder mb-4">Registro</h2>
        <p className="fs-12 fw-medium text-muted">
            Vamos a configurarte todo, para que puedas verificar tu cuenta personal y comenzar a configurar tu perfil.
        </p>
    </>
);
